var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgRectangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 471,
    viewBox: "0 0 1440 471",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1508.04 529.231C1550.82 599.197 1500.46 689 1418.46 689L-22.5199 689C-103.326 689 -153.847 601.545 -113.478 531.545L137.385 96.5376C155.225 65.6021 187.566 45.8546 223.234 44.1168L1120.66 0.392007C1159.02 -1.47657 1195.33 17.7384 1215.36 50.4985L1508.04 529.231Z",
    fill: "url(#paint0_linear_2423_5396)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2423_5396",
    x1: 1377.65,
    y1: 616.902,
    x2: 261.931,
    y2: -52.6064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4940CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D992DF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgRectangle);
export default __webpack_public_path__ + "static/media/BgRectangle.c30ce902f9e8495e497be0f09da03900.svg";
export { ForwardRef as ReactComponent };